import { useReactiveVar } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import LargeButton from '@shared/components/LargeButton';
import { useNavigate } from 'react-router-dom';
import { Page } from '../../layout';
import PrivilegeNames from '../../../constants/privilegeNames.js';
import { isMenuCollapsed, userPrivileges } from '../../../apollo/cache';
import { Breadcrumb } from '@shared/components/breadcrumb/Breadcrumb.js';
import SuccessMessage from '@shared/components/SuccessMessage';
import { useLocation } from 'react-router-dom';
import RecentUpdatesNotifications from './recentUpdatesNotifications/RecentUpdatesNotifications.js';
import TasksDueNotifications from './tasksDueNotifications/TasksDueNotifications.js';

const WelcomePage = () => {
  const privileges = useReactiveVar(userPrivileges);
  const [successMessage, setSuccessMessage] = useState();
  const location = useLocation();
  const pageTitle = 'Data Reports';
  const breadcrumbPathItems = [{ name: pageTitle, url: '' }];

  const navigate = useNavigate();

  useEffect(() => {
    isMenuCollapsed(false);
  }, []);

  useEffect(() => {
    if (location.state && location.state.successMessage) {
      setSuccessMessage(location.state.successMessage);
      navigate(location.pathname);
    }
  }, [location, navigate, setSuccessMessage]);

  return (
    <Page title={pageTitle}>
      <Breadcrumb pathItems={breadcrumbPathItems} />
      <div className='welcome-page'>
        {successMessage && <SuccessMessage message={successMessage} />}
        <h1 className='welcome-page__header'>Welcome!</h1>
        <h2 className='welcome-page__subtitle'>Which Data Report would you like to view?</h2>
        <div className='welcome-page__controls'>
          {privileges.includes(PrivilegeNames.IndustryReports) && (
            <LargeButton
              onClick={() => navigate('/data-reports/industry-reports')}
              subText='View broader industry data trends'>
              Industry Reports
            </LargeButton>
          )}

          {privileges.includes(PrivilegeNames.OrganizationReports) && (
            <LargeButton
              onClick={() => navigate('/data-reports/organization-reports')}
              subText='View individual organizational data'>
              Organization Reports
            </LargeButton>
          )}
        </div>
      </div>
      {privileges.includes(PrivilegeNames.NotificationList) && <RecentUpdatesNotifications />}
      {privileges.includes(PrivilegeNames.TasksDueNotification) && <TasksDueNotifications />}
    </Page>
  );
};

export default WelcomePage;
